module.exports = __webpack_public_path__ + "static/media/comprehensivePlan.f8ef3dd5.png";